import { Action, createAsyncThunk, ThunkAction } from '@reduxjs/toolkit';

import type { AppDispatch, RootState } from '../store';

export type ThunkActionVoid = ThunkAction<void, RootState, void, Action>;
export type ThunkActionReturn<R> = ThunkAction<R, RootState, void, Action>;
export type AsyncThunkActionVoid = ThunkAction<Promise<void>, RootState, void, Action>;
export type AsyncThunkActionReturn<R> = ThunkAction<Promise<R>, RootState, void, Action>;

// I know this isn't the main pattern for defining thunks in the codebase, but it is the recommended pattern in the redux docs:
// https://redux.js.org/tutorials/essentials/part-5-async-logic#reducers-and-loading-actions
export const createAppAsyncThunk = createAsyncThunk.withTypes<{ state: RootState; dispatch: AppDispatch }>();
